import React from "react";
import { SHIP_STATUS, PROGRESS } from "./shippingMeta";

export function ShipStatusBadge({ status, testid }) {
  const s = SHIP_STATUS[status] || { label: status, tone: "#CBD5E1" };
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold" style={{ color: s.tone, borderColor: `${s.tone}55`, background: `${s.tone}14` }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.tone }} />{s.label}
    </span>
  );
}

export function ShipProgress({ status }) {
  const idx = PROGRESS.indexOf(status);
  return (
    <div className="mt-3 flex gap-1" aria-hidden="true">
      {PROGRESS.map((st, i) => (
        <div key={st} className="h-1.5 flex-1 rounded-full transition-colors duration-300" style={{ background: status === "problema_segnalato" ? "#EF444455" : i <= idx ? "#2DD4BF" : "#2A3655" }} />
      ))}
    </div>
  );
}

export function DeclaredNote() {
  return <p className="text-[10px] text-[#64748B]">Stati dichiarati dagli utenti: non verificati automaticamente dal corriere.</p>;
}
